export const BRAND = {
    name: "Santa Lucia Quattro",
    legal: "Santa Lucia Quattro Srl",
    since: 1996,
    email: "info@santaluciaquattro.it",
    phone: "+39 335 804 4517",
    address: "Via Umbria 3, Pietrasanta (LU)",
    hours: "Lun – Ven · 8:00 – 18:00",
    piva: "P.IVA 02031470467",
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export const NAV_LINKS = [
    { id: "chi-siamo", label: "Chi Siamo" },
    { id: "servizi", label: "Servizi" },
    { id: "portfolio", label: "Portfolio" },
    { id: "trent-anni", label: "30 Anni" },
    { id: "recensioni", label: "Recensioni" },
    { id: "contatti", label: "Contatti" },
];

export const HERO_IMAGES = {
    frame: "https://images.unsplash.com/photo-1775923293081-598283c494bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMGl0YWx5JTIwc3RvbmUlMjBwb29sfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
    wide: "https://images.unsplash.com/photo-1678902177251-7ec8fea483a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHxfHxsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMGl0YWx5JTIwc3RvbmUlMjBwb29sfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
    "Ville di Pregio",
    "Restauro Rustici e Dimore Storiche",
    "Piscine Coreografiche",
    "Boutique Hotel & Resort",
    "Finiture d'Arte",
    "Cantiere Chiavi in Mano",
];

export const ABOUT_IMAGES = {
    artisan: "https://images.pexels.com/photos/25596147/pexels-photo-25596147.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    blueprint: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3QlMjBtYXN0ZXIlMjBidWlsZGVyJTIwY29uc3RydWN0aW9uJTIwYmx1ZXByaW50JTIwcGxhbm5pbmd8ZW58MHx8fHwxNzkwMzI3Mzk4fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        id: "ville",
        title: "Ville & Residenze d'Epoca",
        desc: "Costruzione e ristrutturazione di ville singole, appartamenti di pregio e dimore padronali con finiture di alto livello.",
        span: "md:col-span-7",
        image: "https://images.pexels.com/photos/17010997/pexels-photo-17010997.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "restauro",
        title: "Restauro & Recupero Rustici",
        desc: "Conservazione di casali storici, rustici in pietra e volte antiche con metodologie conservative e materiali d'epoca.",
        span: "md:col-span-5",
        image: "https://images.unsplash.com/photo-1704750843798-e7655f99a643?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxoaXN0b3JpYyUyMGl0YWxpYW4lMjBzdG9uZSUyMGhvdXNlJTIwcmVzdG9yYXRpb24lMjBydXN0aWNvfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "piscine",
        title: "Piscine Architettoniche & SPA",
        desc: "Piscine a sfioro, vasche scenografiche e spazi benessere esterni integrati al paesaggio.",
        span: "md:col-span-4",
        icon: "waves",
    },
    {
        id: "hotellerie",
        title: "Hotellerie & Strutture Ricettive",
        desc: "Interventi per boutique hotel e dimore storiche con minimi tempi di fermo operativo.",
        span: "md:col-span-4",
        icon: "hotel",
    },
    {
        id: "chiavi-in-mano",
        title: "Cantiere Chiavi in Mano",
        desc: "Coordinamento completo con architetti, ingegneri e maestranze, dalla burocrazia alle finiture d'interni.",
        span: "md:col-span-4",
        icon: "key",
    },
];

export const PROJECTS = [
    {
        id: "villa-san-martino",
        title: "Villa San Martino",
        location: "Barolo",
        year: "2023",
        specs: "650 mq · Ristrutturazione integrale e parco",
        category: "ville",
        image: "https://images.pexels.com/photos/5581882/pexels-photo-5581882.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        materials: "Cotto fatto a mano, rovere massello, pietra serena",
    },
    {
        id: "dimora-belvedere",
        title: "Dimora Belvedere",
        location: "Chianti",
        year: "2024",
        specs: "820 mq · Nuova costruzione in pietra",
        category: "ville",
        image: "https://images.pexels.com/photos/17010997/pexels-photo-17010997.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        materials: "Pietra faccia a vista, travertino, infissi in bronzo",
    },
    {
        id: "residenza-dei-colli",
        title: "Residenza dei Colli",
        location: "Firenze",
        year: "2022",
        specs: "480 mq · Restauro conservativo",
        category: "ville",
        image: "https://images.unsplash.com/photo-1676276629066-5a0c849a1591?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMGl0YWx5JTIwc3RvbmUlMjBwb29sfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
        materials: "Affreschi restaurati, cotto antico, marmo di Carrara",
    },
    {
        id: "casale-il-rustico",
        title: "Casale Il Rustico",
        location: "Val d'Orcia",
        year: "2023",
        specs: "350 mq · Pietra a vista e travi secolari",
        category: "restauro",
        image: "https://images.unsplash.com/photo-1661171162834-09002458a0f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxoaXN0b3JpYyUyMGl0YWxpYW4lMjBzdG9uZSUyMGhvdXNlJTIwcmVzdG9yYXRpb24lMjBydXN0aWNvfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
        materials: "Pietra recuperata in sito, castagno, calce naturale",
    },
    {
        id: "podere-la-torre",
        title: "Antico Podere La Torre",
        location: "Siena",
        year: "2021",
        specs: "520 mq · Restauro monumentale vincolato",
        category: "restauro",
        image: "https://images.unsplash.com/photo-1704750843798-e7655f99a643?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxoaXN0b3JpYyUyMGl0YWxpYW4lMjBzdG9uZSUyMGhvdXNlJTIwcmVzdG9yYXRpb24lMjBydXN0aWNvfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
        materials: "Mattoni d'epoca, volte in cotto, ferro battuto",
    },
    {
        id: "borgo-antico",
        title: "Borgo Antico",
        location: "Umbria",
        year: "2024",
        specs: "1.100 mq · Riqualificazione borgo storico",
        category: "restauro",
        image: "https://images.pexels.com/photos/38614441/pexels-photo-38614441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        materials: "Pietra locale, coppi originali, legno di recupero",
    },
    {
        id: "piscina-infinity-garda",
        title: "Piscina a Sfioro Infinity",
        location: "Lago di Garda",
        year: "2024",
        specs: "Travertino e solarium deck",
        category: "piscine",
        image: "https://images.unsplash.com/photo-1778205063665-23257f2dc408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHxfHxtb2Rlcm4lMjBsdXh1cnklMjBzd2ltbWluZyUyMHBvb2wlMjB2aWxsYSUyMG91dGRvb3IlMjB0ZXJyYWNlfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
        materials: "Travertino romano, gres effetto sabbia, teak",
    },
    {
        id: "terrazza-como",
        title: "Terrazza Panorama & SPA",
        location: "Como",
        year: "2023",
        specs: "Piscina riscaldata e pergola bioclimatica",
        category: "piscine",
        image: "https://images.pexels.com/photos/36025721/pexels-photo-36025721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        materials: "Mosaico vetrario, pietra di Luserna, alluminio",
    },
    {
        id: "grand-hotel-palazzo",
        title: "Grand Hotel Palazzo",
        location: "Roma",
        year: "2022",
        specs: "Facciate e architravi storici",
        category: "hotellerie",
        image: "https://images.unsplash.com/photo-1764586118429-9caa4ca08439?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMGFyY2hpdGVjdHVyZSUyMHJlc29ydCUyMGl0YWx5JTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzkwMzI3Mzk4fDA&ixlib=rb-4.1.0&q=85",
        materials: "Stucco veneziano, travertino, ottone brunito",
    },
    {
        id: "villa-floridiana",
        title: "Relais Villa Floridiana",
        location: "Amalfi",
        year: "2023",
        specs: "Restauro strutturale e suites di lusso",
        category: "hotellerie",
        image: "https://images.pexels.com/photos/16776928/pexels-photo-16776928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        materials: "Maioliche vietresi, tufo, limonaia in ferro",
    },
];

export const FILTERS = [
    { id: "tutti", label: "Tutti" },
    { id: "ville", label: "Ville & Appartamenti" },
    { id: "restauro", label: "Restauro Rustici" },
    { id: "piscine", label: "Piscine" },
    { id: "hotellerie", label: "Hotellerie" },
];

export const DEFAULT_SERVICES_PAGE = [
    {
        title: "Ville & Residenze d'Epoca",
        text: "Costruiamo e ristrutturiamo ville singole, appartamenti di pregio e dimore padronali. Seguiamo ogni fase — dal rilievo iniziale alle finiture — con materiali selezionati e maestranze proprie, per un risultato che unisce estetica, comfort e durata nel tempo.",
        photo: "https://images.pexels.com/photos/17010997/pexels-photo-17010997.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        title: "Restauro & Recupero Rustici",
        text: "Il recupero dei rustici è la nostra specialità: casali storici, pietra a vista, volte antiche e travi secolari. Interveniamo con metodologie conservative e materiali d'epoca, nel rispetto dei vincoli e della storia di ogni edificio.",
        photo: "https://images.unsplash.com/photo-1704750843798-e7655f99a643?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxoaXN0b3JpYyUyMGl0YWxpYW4lMjBzdG9uZSUyMGhvdXNlJTIwcmVzdG9yYXRpb24lMjBydXN0aWNvfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
    },
    {
        title: "Piscine Architettoniche & SPA",
        text: "Progettiamo e realizziamo piscine a sfioro, vasche scenografiche e spazi benessere esterni integrati nel paesaggio. Curiamo struttura, impianti e rivestimenti per un'acqua perfetta e una manutenzione semplice.",
        photo: "https://images.unsplash.com/photo-1778205063665-23257f2dc408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHxfHxtb2Rlcm4lMjBsdXh1cnklMjBzd2ltbWluZyUyMHBvb2wlMjB2aWxsYSUyMG91dGRvb3IlMjB0ZXJyYWNlfGVufDB8fHx8MTc5MDMyNzM4OXww&ixlib=rb-4.1.0&q=85",
    },
    {
        title: "Hotellerie & Strutture Ricettive",
        text: "Lavoriamo per boutique hotel, alberghi e dimore storiche con interventi pianificati per ridurre al minimo i tempi di fermo. Efficienza organizzativa, cantieri puliti e consegne puntuali, anche a struttura aperta.",
        photo: "https://images.unsplash.com/photo-1764586118429-9caa4ca08439?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMGFyY2hpdGVjdHVyZSUyMHJlc29ydCUyMGl0YWx5JTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzkwMzI3Mzk4fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        title: "Gestione Cantiere Chiavi in Mano",
        text: "Coordiniamo tutto noi: architetti, ingegneri, pratiche burocratiche e maestranze specializzate, fino alle finiture d'interni. Un unico referente, un cronoprogramma chiaro e nessuna sorpresa in corso d'opera.",
        photo: "",
    },
];

export const STATS = [
    { value: 30, suffix: "+", label: "Anni di Esperienza" },
    { value: 180, suffix: "+", label: "Progetti Completati" },
    { value: 100, suffix: "%", label: "Consegne Puntuali" },
    { value: 45, suffix: "+", label: "Maestranze Qualificate" },
];

export const PROPERTY_TYPES = [
    "Villa / Appartamento",
    "Rustico / Casale",
    "Piscina / Esterni",
    "Hotel / Struttura ricettiva",
];
